import React from 'react';

const CompanyPage = () => {
  return (
    <div className="doc-page company">
      <h1>運用者情報</h1>

      <p>サイト名: ガーリックハムスター</p>
      <p>運営者名: ガーリック・ハムスター</p>
      <p>お問い合わせ: contact@garlic-hamster.com</p>
      <p>本サービスは個人プロジェクトとして運営されています。</p>

      <p>最終更新日：2025年12月15日</p>
    </div>
  );
};

export default CompanyPage;
